import { useEffect } from 'react'
import RestTrackingController from '../../../hooks/RestTrackingController'
import Swal from 'sweetalert2'
import { SweetAlertIcon } from '../../../utils/Constants'
import { useTranslation } from 'react-i18next'

const TrackingProjectsController = (model) => {
  const { t } = useTranslation()

  // hooks
  const { rest } = RestTrackingController();

  useEffect(() => {
    handleSearchProjects()
  }, [])

  // functions
  const handleSearchProjects = () => {

    const params = {};

    model.setIsLoading((prev) => ({ ...prev, projects: true }));
    const getAllProjects = rest({ params, endpoint: 'getTrackingProjects'})
      .then((data) => {
        model.setProjects(data.projects);
        model.setLimit(data.projectsMax)
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setProjectsLoaded(true)
        model.setIsLoading((prev) => ({ ...prev, projects: false }))
      })
  }


  const handleAddProjectClick = (projectId) => {
    const params = {}
    params.projectId = projectId

    model.setIsLoading((prev) => ({ ...prev, projects: true }));
    const addProjects = rest({ params, endpoint: 'addTrackingProject'})
      .then((data) => {
        handleSearchProjects()
      })
      .catch((error) => {
        if(error.status===429){ // limit reached
          Swal.fire({
            position: "top-end",
            text: t('errorLimitReached'),
            icon: SweetAlertIcon.ERROR,
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            timerProgressBar: true,
            showCloseButton: true
          });
        } else {
          console.error(`Error:`, error)
        }
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, projects: false }))
      })
  }

  const handleOnDeleteClick = (row) => {
    const params = { projectId: row.id };

    model.setIsLoading((prev) => ({ ...prev, projects: true }));
    const deleteProject = rest({ params, endpoint: 'delTrackingProject'})
      .then((data) => {
        handleSearchProjects()
      })
      .catch((error) => {
        console.error(`Error:`, error);
      })
      .finally(() => {
        model.setIsLoading((prev) => ({ ...prev, projects: false }))
      })
  }

  return {
    handleOnboardingAddProjectClick: handleAddProjectClick,
    handleOnDeleteClick
  }
}

export default TrackingProjectsController;